<!-- 设施说明组件 -->
<template>
	<div class="container" v-if="JSON.stringify(datas) !== '{}'">
		<div class="column" v-if="orderType != 5 && orderType != 1">
			<div class="columnText1">
				预定说明
			</div>
			<reserve :datas="datas" :state="state"></reserve>
		</div>
		<div class="column" v-if="orderType != 5 && orderType != 1">
			<div class="columnText1">
				费用说明
			</div>
			<cost :orderType="orderType" :datas="datas" :state="state"></cost>
		</div>
		<div class="column" v-if="orderType != 5 && orderType != 1">
			<div class="columnText1">
				使用说明
				<!-- <span @click="openDescriptionPopup('使用说明', 'useExplain')" class="columnText2">添加使用说明的文字描述</span> -->
			</div>
			<hotel-use :datas="datas" v-if="state == 0"></hotel-use>
			<site-use :datas="datas" v-if="state == 1"></site-use>
			<spot-use :datas="datas" v-if="state == 2 || state == 8"></spot-use>
			<!-- <traffic-use   :datas="datas" v-if="state == 3"></traffic-use> -->
			<restaurant-use :datas="datas" v-if="state == 4"></restaurant-use>
			<guide-use :datas="datas" v-if="state == 5"></guide-use>
			<!-- <visa-use    :datas="datas" v-if="state == 6"></visa-use> -->
			<!-- <business-use   :datas="datas" v-if="state == 7 || state == 9"></business-use> -->
		</div>
		<div class="column">
			<div class="columnText1">
				退改说明
				<!-- <span @click="openDescriptionPopup('退改说明', 'cancelExplain')" class="columnText2">添加退改说明的文字描述</span> -->
			</div>
			<ticket :datas="datas"></ticket>
		</div>
		<div class="column">
			<div class="columnText1">
				其他说明
			</div>
			<other :datas="datas"></other>
		</div>
		<!-- <div class="column">
			<div class="columnText1">
				图片维护
				<div style="display: flex;align-items: center;">
					<div class="imgBtns" style="margin-right: 18rpx;">
						上传房间照片
					</div>
					<div class="imgBtns">
						上传酒店照片
					</div>
				</div>
			</div>
			<img-maintain></img-maintain>
		</div> -->
	</div>
</template>

<script>
import reserve from './detail/reserve.vue' //预定说明
import cost from './detail/cost.vue' //费用说明
import other from './detail/other.vue' //其它说明
import ticket from './detail/ticket.vue' //退改说明
// import imgMaintain from './detail/imgMaintain.vue' //图片维护
import hotelUse from './detail/hotelUse.vue' //使用说明
import siteUse from './detail/siteUse.vue' //使用说明
import spotUse from './detail/spotUse.vue' //使用说明
import guideUse from './detail/guideUse.vue' //使用说明
// import trafficUse from './detail/trafficUse.vue' //使用说明
// import businessUse from './detail/businessUse.vue' //使用说明
import restaurantUse from './detail/restaurantUse.vue' //使用说明
// import visaUse from './detail/visaUse.vue' //使用说明

export default {
	components: {
		reserve,
		cost,
		other,
		ticket,
		// imgMaintain,
		hotelUse,
		siteUse,
		spotUse,
		guideUse,
		// trafficUse,
		// businessUse,
		restaurantUse,
		// visaUse
	},
	props: {
		state: {
			type: Number,
			default: 0,
		},
		datas: {
			type: Object,
			default: {},
		},
		orderType: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			descriptionTitle: '',
			keys: '', //记录描述字段
		}
	},
	methods: {
		//更新数据
		updateDatas(val) {
			this.datas = val
			console.log(val, '我触发监听了');
		},
		//打开描述弹框
		openDescriptionPopup(type, key) {
			this.descriptionTitle = type
			this.keys = key
			this.$refs.newTextarea.reason = JSON.parse(JSON.stringify(this.datas[key]))
			this.$refs.descriptionTitlePopup.handleShowShare()
		},
		//保存描述
		saveDescription() {
			let text = this.$refs.newTextarea.reason
			this.$set(this.datas, this.keys, text)
			uni.showToast({
				title: '保存成功',
				icon: 'none',
				duration: 1000
			});
		},


	}
}
</script>

<style lang="scss" scoped>
.container {
	padding: 0.1rem;

	.column {
		margin-bottom: 0.2rem;

		.columnText1 {
			color: rgba(73, 104, 120, 1);
			font-size: 0.16rem;
			font-family: PingFangSC-medium;
			margin-bottom: 0.1rem;
			font-weight: bold;
			display: flex;
			justify-content: space-between;

			.imgBtns {
				width: 170rpx;
				height: 50rpx;
				line-height: 50rpx;
				border-radius: 30rpx 30rpx 30rpx 30rpx;
				background-color: rgba(255, 255, 255, 1);
				color: rgba(230, 74, 25, 1);
				font-size: 20rpx;
				text-align: center;
				border: 2rpx solid rgba(251, 232, 225, 1);
			}

			.columnText2 {
				color: rgba(230, 74, 25, 1);
				font-size: 20rpx;
				font-family: PingFangSC-light;
			}
		}
	}
}
</style>
